const keyboardHeight = 320; // this is the approximate keyboard height
// this is an offset that needed in order to have the focused element clearly visible
const scrollOffset = 30;
const scrollToDuration = 200;

/**
 * This permits you show the whole application when scrolling. If you don't apply
 * this, when the keyboard opens will just overlay the page as a result you will not
 * be able to see the bottom elements of the page.
 * @returns {boolean}
 */
function isKeyboardOverlapping() {
  return (
    Pollfish.ui.initialDimensions.width === $(window).width() &&
    Pollfish.ui.initialDimensions.height === $(window).height()
  );
}

/**
 * Returns true when the focused element is being overlapped from the keyboard
 * @param $elem
 * @constructor
 */
function isOverlappedByKeyboard($elem) {
  return (
    $elem.offset().top + scrollOffset >
    Pollfish.ui.initialDimensions.height - keyboardHeight - scrollOffset
  );
}

// eslint-disable-next-line import/prefer-default-export
export function FocusElement($elem = $('html'), otherElement) {
  const $wrapper = $('html, body');
  const $wrapperHolder = $('.wrapper__holder');
  const blurTimeouts = [];
  // we are going to use visualViewport property for iOS(Safari),
  // which returns the available screen size excluding on screen keyboard
  // https://developer.mozilla.org/en-US/docs/Web/API/Visual_Viewport_API
  const { visualViewport } = window;
  let viewHeight = Pollfish.helper.getStylePropertyViewHeight();

  $elem.on('focus', () => {
    viewHeight = Pollfish.helper.getStylePropertyViewHeight();
    // no need to listen for resize
    // prevent flickering of submit button while focusing inputs on testing environment
    if (Pollfish.helper.isCypressEnv()) {
      return;
    }
    let resizeHandled = false;

    $wrapperHolder.removeClass('open-keyboard');

    // the resize event should be triggered only when the keyboard pushes
    // the content and the viewport resizes
    // on iphone(Safari) and possibly in other apple devices the resize event
    // does not trigger when the keyboard appears
    $(window).on('resize', (e) => {
      if (resizeHandled === true) {
        e.preventDefault();
        return;
      }
      blurTimeouts.push(
        setTimeout(() => {
          resizeHandled = true;
          if (isOverlappedByKeyboard($elem)) {
            // we may need to scroll to another element when focusing the input
            const currentElementPosition =
              $elem.offset().top + $wrapper.scrollTop();
            const otherElementPosition =
              otherElement && $(otherElement).offset().top;
            const scrollToPosition = otherElement
              ? otherElementPosition
              : currentElementPosition;
            $wrapper.animate({ scrollTop: scrollToPosition }, scrollToDuration);
          }
        }),
      );
    });

    // this will run if we the keyboard is not pushing the content/viewport and in the
    // cases that the resize event has not been fired in a short time. This mostly
    // is happened in the majority of the low-end devices and also in iphone(Safari).
    blurTimeouts.push(
      setTimeout(() => {
        if (resizeHandled) {
          return;
        }
        resizeHandled = true;
        // we may need to scroll to another element when focusing the input
        const currentElementPosition =
          $elem.offset().top + $wrapper.scrollTop();
        const otherElementPosition =
          otherElement && $(otherElement).offset().top;
        const scrollToPosition = otherElement
          ? otherElementPosition
          : currentElementPosition;
        if (isKeyboardOverlapping() && Pollfish.helper.isAndroid()) {
          $wrapperHolder.addClass('open-keyboard');
          if (isOverlappedByKeyboard($elem)) {
            // adding keyboardHeight when trying to scroll on otherElement seems to be off in android
            const finalPosition = otherElement
              ? scrollToPosition
              : scrollToPosition + keyboardHeight;
            $wrapper.animate({ scrollTop: finalPosition }, scrollToDuration);
          }
        } else if (isKeyboardOverlapping() && Pollfish.helper.isIOS()) {
          if (visualViewport) {
            Pollfish.helper.setStylePropertyViewHeight(
              `${visualViewport.height}px`,
            );
          } else {
            $wrapperHolder.addClass('open-keyboard');
            if (isOverlappedByKeyboard($elem)) {
              $wrapper.animate(
                { scrollTop: scrollToPosition + keyboardHeight },
                scrollToDuration,
              );
            }
          }
        } else if (Pollfish.helper.hasIOSNavigator() && visualViewport) {
          Pollfish.helper.setStylePropertyViewHeight(
            `${visualViewport.height}px`,
          );
        } else {
          $wrapper.animate({ scrollTop: scrollToPosition }, scrollToDuration);
        }
      }, 250),
    );
  });

  $elem.on('blur', () => {
    // clear timeouts and resize listeners
    blurTimeouts.forEach((timeout) => {
      clearTimeout(timeout);
    });
    $(window).off('resize');

    // set document style vh property back to the origin height before keyboard appears
    if (Pollfish.helper.hasIOSNavigator() && visualViewport) {
      Pollfish.helper.setStylePropertyViewHeight(viewHeight);
    }

    $wrapperHolder.removeClass('open-keyboard');
  });
}
